function formatMoney(cents) {
  let euros = cents / 100;
  return `€${euros.toFixed(2).replace(".", ",")}`;
}



document.addEventListener("DOMContentLoaded", function () {
  let variantSelections = document.querySelectorAll(".variant-select");
  let accordions = document.querySelectorAll(".accordion-item");
  let dropdowns = document.querySelectorAll(".variant-dropdown");
  let confirmButtons = document.querySelectorAll(".confirm-step");
  let lastStepButton = document.querySelector(".last-step-button");
  let selectedVariants = {};
  let defaultPrices = {};
  let totalSteps = accordions.length;

  lastStepButton.setAttribute("disabled", "true");

  dropdowns.forEach((dropdown) => {
    let productId = dropdown.getAttribute("data-product-id");
    let firstOption = dropdown.querySelector("option[data-price]");
    if (firstOption) {
      defaultPrices[productId] = parseFloat(firstOption.getAttribute("data-price")) || 0;
    }
  });

  accordions.forEach((accordion) => {
    accordion.querySelector(".accordion-header").addEventListener("click", function () {
      let stepIndex = parseInt(accordion.getAttribute("data-step"));
      let confirmedSteps = [...document.querySelectorAll(".confirm-step.confirmed")]
        .map(btn => parseInt(btn.getAttribute("data-step")));
      const maxConfirmed = confirmedSteps.length > 0 ? Math.max(...confirmedSteps) : -1;
      const isAllowed = stepIndex === 0 || confirmedSteps.includes(stepIndex) || stepIndex === maxConfirmed + 1;

      if (!isAllowed) return;

      let content = accordion.querySelector(".accordion-content");
      let isOpen = content.style.display === "block";
      document.querySelectorAll(".accordion-content").forEach((c) => (c.style.display = "none"));
      content.style.display = isOpen ? "none" : "block";
    });
  });

variantSelections.forEach((variant) => {
  variant.addEventListener("click", function () {
    const productId = this.getAttribute("data-product-id");
    const clickedIndex = parseInt(this.getAttribute("data-option-index"));
    const clickedValue = this.getAttribute("color-title") || this.innerText.trim() || this.title;


    const variantContainer = this.closest(".variant-options");
    const allGroups = Array.from(variantContainer.querySelectorAll(".variant-options-wrapper"));

    // Step 1: Gather options from other groups
    const otherGroupsOptions = allGroups.map((group, index) => {
      const options = Array.from(group.querySelectorAll(".variant-select")).map(opt => ({
        el: opt,
        value: opt.innerText.trim() || opt.title
      }));
      return { index, options };
    });

    // Step 2: Update disabled state based on combinations
    otherGroupsOptions.forEach(group => {
      if (group.index === clickedIndex) return; // Skip clicked group

      group.options.forEach(optionObj => {
        const trialCombo = [];

        for (let i = 0; i < allGroups.length; i++) {
          if (i === clickedIndex) {
            trialCombo[i] = clickedValue;
          } else if (i === group.index) {
            trialCombo[i] = optionObj.value;
          } else {
            const selected = selectedVariants[productId]?.[i];
            if (!selected) {
              trialCombo[i] = null;
            } else {
              trialCombo[i] = selected;
            }
          }
        }

        // Skip incomplete combinations
        if (trialCombo.includes(null)) {
          optionObj.el.classList.remove("disabled");
          return;
        }

        const comboStr = trialCombo.join(",");
        const dropdown = document.querySelector(`#variant-dropdown-${productId}`);
        const match = [...dropdown.options].find(opt => opt.dataset.options === comboStr);

        if (match && parseInt(match.dataset.qty) === 0) {
          optionObj.el.classList.add("disabled");
        } else {
          optionObj.el.classList.remove("disabled");
        }
      });
    });

    // Step 3: Update selectedVariants
    if (!selectedVariants[productId]) selectedVariants[productId] = {};
    selectedVariants[productId][clickedIndex] = clickedValue;

    let siblings = this.closest(".variant-options-wrapper").querySelectorAll(".variant-select");
    siblings.forEach((sib) => sib.classList.remove("selected"));
    this.classList.add("selected");

    const dropdown = document.querySelector(`#variant-dropdown-${productId}`);
    const stepIndex = this.closest(".accordion-item")?.getAttribute("data-step");
    const confirmButton = document.querySelector(`.confirm-step[data-step="${stepIndex}"]`);

    const variantOptionsString = Object.values(selectedVariants[productId]).join(",");
    const matchingOption = [...dropdown.options].find((opt) => opt.dataset.options === variantOptionsString);

    if (matchingOption) {
      if (parseInt(matchingOption.dataset.qty) === 0) {
        alert("This item is sold out.");
      } else {
        dropdown.value = matchingOption.value;
        confirmButton?.removeAttribute("disabled");
        updateTotalPrice();
      }
    }

    checkAllStepsCompleted();
  });
});


  

  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener("change", function () {
      let productId = this.getAttribute("data-product-id");
      let selectedOption = this.options[this.selectedIndex];
      let variantOptions = selectedOption.dataset.options.split(",");

      selectedVariants[productId] = {};
      let optionElements = document.querySelectorAll(`.variant-select[data-product-id='${productId}']`);

      optionElements.forEach((optionEl) => {
        let optionIndex = optionEl.getAttribute("data-option-index");
        let value = optionEl.innerText || optionEl.title;
        if (variantOptions.includes(value)) {
          optionEl.classList.add("selected");
          selectedVariants[productId][optionIndex] = value;
        } else {
          optionEl.classList.remove("selected");
        }
      });

      updateTotalPrice();
      checkAllStepsCompleted();
    });
  });

  confirmButtons.forEach((button) => {
    button.addEventListener("click", function () {
      let stepIndex = parseInt(this.getAttribute("data-step"));
      this.classList.add("confirmed");

      let nextStep = document.querySelector(`.accordion-item[data-step="${stepIndex + 1}"]`);
      if (nextStep) {
        document.querySelectorAll(".accordion-content").forEach((c) => (c.style.display = "none"));
        nextStep.querySelector(".accordion-content").style.display = "block";
      }

      checkAllStepsCompleted();
    });
  });

  function checkAllStepsCompleted() {
    let selectedCount = Object.keys(selectedVariants).length;
    if (selectedCount === totalSteps && allVariantsSelected()) {
      lastStepButton.removeAttribute("disabled");
    } else {
      lastStepButton.setAttribute("disabled", "true");
    }
  }

  function allVariantsSelected() {
    return Object.keys(selectedVariants).every((productId) => {
      let dropdown = document.querySelector(`#variant-dropdown-${productId}`);
      return dropdown && dropdown.value !== "";
    });
  }

  function updateTotalPrice() {
    let originalPrice = 0;

    dropdowns.forEach((dropdown) => {
      let productId = dropdown.getAttribute("data-product-id");
      let selectedValue = dropdown.value;
      let selectedOption = [...dropdown.options].find(opt => opt.value === selectedValue);
      let price = selectedOption?.getAttribute("data-price");
      originalPrice += price ? parseFloat(price) : (defaultPrices[productId] || 0);
    });

    const discountEl = document.querySelector("[discount-percent]");
    const comparePriceDisplay = document.querySelector(".bundlecomparepricecustom");
    let discountedPrice = originalPrice;

    if (discountEl && comparePriceDisplay) {
      let discountPercent = parseFloat(discountEl.getAttribute("discount-percent"));
      if (!isNaN(discountPercent) && discountPercent > 0 && discountPercent < 100) {
        discountedPrice = originalPrice - (originalPrice * discountPercent / 100);

        // Show compare (original) price
        comparePriceDisplay.classList.remove("hide");
        comparePriceDisplay.querySelector("span").innerText = formatMoney(originalPrice);
      } else {
        comparePriceDisplay.classList.add("hide");
      }
    }

    // Final discounted display price
    let priceDisplay = document.querySelector(".bundlepricecustom span");
    if (priceDisplay) priceDisplay.innerText = formatMoney(discountedPrice);

    let addToCartPrice = document.querySelector(".add-to-cart-price");
    if (addToCartPrice) addToCartPrice.innerText = ` (${formatMoney(discountedPrice)})`;
  }

  lastStepButton.addEventListener("click", function () {
    let variantIDs = [];

    document.querySelectorAll(".variant-dropdown").forEach((select) => {
      let variantId = select.value;
      if (variantId) variantIDs.push(variantId);
    });

    lastStepButton.setAttribute("disabled", "true");
    lastStepButton.innerText = "Adding...";

    addToCart(variantIDs);
  });

  function addToCart(variantIDs) {
    if (variantIDs.length === 0) return;

    let items = variantIDs.map((id) => ({ id: id, quantity: 1 }));

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: items }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.text().then((text) => {
            throw new Error(`Server Error: ${text}`);
          });
        }
        return response.json();
      })
      .then(() => {
        lastStepButton.innerText = "Added!";
        setTimeout(() => {
          window.location.href = "/cart";
        }, 2000);
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
        lastStepButton.innerText = "Add to Bag";
        lastStepButton.removeAttribute("disabled");
      });
  }

  updateTotalPrice();
});
